/**
 *
 */
const win: typeof window = import.meta.env.SSR ? (globalThis as never) : window;

if (import.meta.env.SSR) {
  const set = /*                      */ (
    target: Record<PropertyKey, unknown>,
    prop: PropertyKey,
    value: unknown,
  ): boolean => {
    /*                                                                                  */
    if (!!target[prop] && typeof value === "function") {
      return true;
    }

    /*                                                                                                                               */
    /*                                                                                                                */
    if (!!target[prop] && typeof target[prop] === "object") {
      Object.assign(target[prop], value);
      return true;
    }

    /*                                                              */
    target[prop] =
      /*                                                               */
      typeof value === "object" && value !== null ? new Proxy(value, { get, set }) : value;
    return true;
  };

  const get = /*                      */ (
    target: Record<PropertyKey, unknown>,
    prop: PropertyKey,
  ): unknown => {
    /*                                                                                        */
    if (target[prop] !== undefined) return target[prop];

    /*                                                  */
    if (import.meta.env.MODE === "test") {
      if (["$$typeof", "_isMockFunction"].includes(prop as string)) return undefined;
      if (prop.toString().startsWith("@@__")) return undefined;
    }

    /*                                                                                                              */
    target[prop] = new Proxy(() => {}, { get, set } as never);
    return target[prop];
  };

  /**
 *
 */
  win.o_global ||= get({}, "o_global") as never;
  win.o_util ||= get({}, "o_util") as never;
} else {
  /**
 *
 *
 *
 */
  /*                                                                 */
  win.o_global ||= {} as never;
  win.o_util ||= {} as never;
}

/*                   */
export { win };
export const { o_global, o_util } = win;
